
import React from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer, putDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { ToastSuccess } from '../../../constants/Toast';
import Container from '../../../constants/Container';
import SecHeading from '../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../constants/InputTextBox';
import NepaliInputBox from '../../../constants/NepaliInputBox';
import { handleNepaliInputChange } from '../../../helpers/handleChange';
import { EndBaseLine } from '../../../constants/AppSpace';
import { Button } from '../../../constants/Button';
import { provinceValidationSchema } from '../../../helpers/validation';
import useFetchData from '../../../helpers/useFetch';
import useFetchSubData from '../../../helpers/useSubFetch';

interface AuthorCreateFormViewProps {
    handleFormSuccess: () => void;
    onID: number | null;
}

const ProvinceEditView: React.FC<AuthorCreateFormViewProps> = ({ handleFormSuccess, onID }) => {
    const { data, loading, error } = useFetchSubData(AppURL.FrontOfficeURL + 'front/province/retrieve/update/view/'+onID, onID);
    const initialValues = {
        province_name: loading || !data ? "" : data.data?.province_name || "",
        province_name_nep: loading || !data ? "" : data.data?.province_name_nep || "",
    };
    const { values, errors, touched, resetForm, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: provinceValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("province_name", values.province_name);
            formData.append("province_name_nep", values.province_name_nep);
            try {
                await putDataToTheServer(AppURL.FrontOfficeURL + 'front/province/retrieve/update/view/'+onID, formData).then((res) => {
                    handleFormSuccess();
                    ToastSuccess({ message: res?.message });
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>

            <form onSubmit={handleSubmit}>
                <SecHeading type='update' label='Province Update' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='province_name'
                            label='Province Name'
                            handleChange={handleChange}
                            value={values.province_name}
                            error={typeof errors.province_name === 'string' ? errors.province_name : undefined}
                            handleBlur={handleBlur}
                            required={true}
                            placeholder='Enter Province Name'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Name(Nepali)'
                            name='province_name_nep'
                            value={values.province_name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'province_name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={typeof errors.province_name_nep === 'string' ? errors.province_name_nep : undefined}
                            placeholder='Enter nepali name'
                        />
                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='update' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default ProvinceEditView